/**
 * Format link block to url.
 * @param {object} data
 * @returns {string}
 */

import { isLocalURL } from './browser';
import { getLocation } from './location';
import { getSiteContext } from './site-context';

export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = '';
    switch (linkTo) {
    case 'email':
        url = 'mailto:' + data[linkTo];
        break;
    case 'anchor':
        url = '#' + data[linkTo];
        break;
    case 'custom_url':
        url = data?.customUrl;
        break;
    case 'file':
        url = data[linkTo].url;
        break;
    case 'page':
        url = data[linkTo]?.url;
        break;
    case 'phone':
        url = 'tel:' + data[linkTo];
        break;
    }

    return url;
};


export const formatUrlWithActiveFund = (url) => {
    if (url && isLocalURL(url)) {
        const currentUrl = new URL(url, getLocation()?.origin);
        const siteContext = getSiteContext();
        const fundSlug = siteContext.fundSlug;
        const fundPages = siteContext.fundPages?.map?.(f => f.slug);

        if (fundSlug && fundPages?.length > 0 && currentUrl.pathname !== '/') {
            const segments = currentUrl.pathname.split('/').filter(Boolean);

            if (!fundPages.includes(segments?.[0])) {
                currentUrl.pathname = `/${fundSlug}/${segments.join('/')}`;
            }
        }

        return currentUrl.pathname;
    } else {
        return url;
    }
};
